(function () {
  document.addEventListener('variant:add', async function () {
    const checkboxes = document.querySelectorAll('.service-addon__checkbox:checked');
    if (checkboxes.length === 0) return;

    const items = Array.from(checkboxes).map(function (cb) {
      return { id: parseInt(cb.dataset.variantId, 10), quantity: 1 };
    });

    try {
      const response = await fetch(
        (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        }
      );

      if (!response.ok) {
        const err = await response.json();
        console.error('[service-addons] Cart add failed:', err);
        return;
      }

      checkboxes.forEach(function (cb) { cb.checked = false; });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {
      console.error('[service-addons] Network error:', e);
    }
  });
})();
